import {RoutingState} from "../../type/routing-state";

export const clearRoutingSummaryDispatch = (state: RoutingState) => {
  state.monthlyLogs = undefined;
};
